var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreateBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7768_47800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.02219 20 6.08879 19.4135 4.4443 18.3147C2.79981 17.2159 1.51809 15.6541 0.761209 13.8268C0.00433286 11.9996 -0.193701 9.98891 0.192152 8.0491C0.578004 6.10929 1.53041 4.32746 2.92894 2.92894C4.32746 1.53041 6.10929 0.578004 8.0491 0.192152C9.98891 -0.193701 11.9996 0.00433286 13.8268 0.761209C15.6541 1.51809 17.2159 2.79981 18.3147 4.4443C19.4135 6.08879 20 8.02219 20 10C19.9971 12.6513 18.9426 15.1932 17.0679 17.0679C15.1932 18.9426 12.6513 19.9971 10 20ZM10 1.66667C8.35183 1.66667 6.74066 2.15541 5.37025 3.07109C3.99984 3.98677 2.93174 5.28826 2.30101 6.81098C1.67028 8.33369 1.50525 10.0092 1.82679 11.6258C2.14834 13.2423 2.94201 14.7271 4.10745 15.8926C5.27289 17.058 6.75774 17.8517 8.37425 18.1732C9.99076 18.4948 11.6663 18.3297 13.189 17.699C14.7118 17.0683 16.0132 16.0002 16.9289 14.6298C17.8446 13.2593 18.3333 11.6482 18.3333 10C18.3309 7.79061 17.4522 5.67241 15.8899 4.11013C14.3276 2.54785 12.2094 1.6691 10 1.66667Z",
    fill: "#4A5564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8307C9.77899 15.8307 9.56703 15.7429 9.41075 15.5867C9.25447 15.4304 9.16667 15.2184 9.16667 14.9974V4.9974C9.16667 4.77638 9.25447 4.56442 9.41075 4.40814C9.56703 4.25186 9.77899 4.16406 10 4.16406C10.221 4.16406 10.433 4.25186 10.5893 4.40814C10.7455 4.56442 10.8333 4.77638 10.8333 4.9974V14.9974C10.8333 15.2184 10.7455 15.4304 10.5893 15.5867C10.433 15.7429 10.221 15.8307 10 15.8307Z",
    fill: "#4A5564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8307H5.00001C4.77899 10.8307 4.56703 10.7429 4.41075 10.5867C4.25447 10.4304 4.16667 10.2184 4.16667 9.9974C4.16667 9.77638 4.25447 9.56442 4.41075 9.40814C4.56703 9.25186 4.77899 9.16406 5.00001 9.16406H15C15.221 9.16406 15.433 9.25186 15.5893 9.40814C15.7455 9.56442 15.8333 9.77638 15.8333 9.9974C15.8333 10.2184 15.7455 10.4304 15.5893 10.5867C15.433 10.7429 15.221 10.8307 15 10.8307Z",
    fill: "#4A5564"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7768_47800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreateBusiness);
export default __webpack_public_path__ + "static/media/icon-create-business.05842d41.svg";
export { ForwardRef as ReactComponent };